import script from "./MinorRegulation.vue?vue&type=script&setup=true&lang=js"
export * from "./MinorRegulation.vue?vue&type=script&setup=true&lang=js"

import "./MinorRegulation.vue?vue&type=style&index=0&id=257a727a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-257a727a"]])

export default __exports__